module.exports = __webpack_public_path__ + "static/media/plantronics-backbeat-fit-500.a1cb6e9b.png";